function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5195 11.52C12.415 11.52 11.5195 12.4155 11.5195 13.52V44.08C11.5195 45.1846 12.415 46.08 13.5195 46.08H34.5595V39.744C34.5595 38.4768 35.7259 37.44 37.1515 37.44H54.7195V13.52C54.7195 12.4155 53.8241 11.52 52.7195 11.52H13.5195Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5195 13.52H52.7195L52.7195 37.44H54.7195V13.52C54.7195 12.4155 53.8241 11.52 52.7195 11.52H13.5195C12.415 11.52 11.5195 12.4155 11.5195 13.52V44.08C11.5195 45.1846 12.415 46.08 13.5195 46.08H34.5595V44.08H13.5195V13.52Z",
  fill: "#323232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.96 21.6H53.28",
  stroke: "#323232",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 18.7193,
  cy: 17.28,
  rx: 1.44,
  ry: 1.44,
  fill: "#323232"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.0396,
  cy: 17.28,
  rx: 1.44,
  ry: 1.44,
  fill: "#323232"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27.3589,
  cy: 17.28,
  r: 1.44,
  fill: "#323232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.5676 54.0081H53.8613L54.1084 54.1669L56.5996 55.7684V42.0481C56.5996 41.789 56.2903 41.3201 55.5836 41.3201H39.4556C38.7489 41.3201 38.4396 41.789 38.4396 42.0481V53.2801C38.4396 53.5391 38.7489 54.0081 39.4556 54.0081H53.5676Z",
  fill: "#5B638F",
  stroke: "#323232",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.0329 26.6455L24.4793 30.7485L30.0327 34.8513",
  stroke: "#323232",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.4603 26.6453L42.0139 30.7484L36.4604 34.8512",
  stroke: "#323232",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  fill: "white"
})));

function SvgTechnicalMentor(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,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";
export { SvgTechnicalMentor as ReactComponent };